<template lang="pug">
b-modal#loginModal.modal.fade(
  centered,
  hide-footer="",
  title="EETI Member Sign In",
  tabindex="-1",
  aria-labelledby="loginModal",
  aria-hidden="true"
)
  form
    .form-group
      input#mail.form-control(
        type="text",
        v-model="email",
        placeholder="E-mail",
        :class="{ 'is-invalid': emailCheck, 'bg-light': emailCheck, 'border-0': emailCheck }"
      )
      small.invalid-feedback Please provide a valid Email.
    .form-group
      input#password.form-control(
        type="password",
        v-model="password",
        :class="{ 'is-invalid': passwordCheck, 'bg-light': passwordCheck, 'border-0': passwordCheck }",
        placeholder="Password"
      )
      small.invalid-feedback Please provide a valid Password.
      .invalid-feedback.d-block(v-if="serverMessageCheck") {{ serverMessage }}
    .form-group
      small
        a(
          v-b-modal.forgotPasswordModal="",
          @click="$bvModal.show('forgotPasswordModal')",
          data-toggle="modal",
          data-target="#forgotPasswordModal"
        ) Forget Password?
    .form-group
      .btn.btn-primary.btn-block(@click="loginClick") Sign In
    .form-group
      a.underline(href="/register") Register for an account
  dialog-text-btn(
    @onDialogTextBtnClick="onDialogTextBtnClick",
    :title="dialogTextBtnData.title",
    :content="dialogTextBtnData.content",
    :btn="dialogTextBtnData.btn"
  )
  dialog-forgot-password(
    @onSendPasswordSuccess="onSendPasswordSuccess",
    @onSendPasswordFail="onSendPasswordFail"
  )
  dialog-completed(:text="sendPasswordText")
</template>

<script>
import { mapActions } from "vuex";
import { getAccount } from "@/utils/auth";
import DialogTextBtn from "@/components/common/DialogTextBtn";
import DialogForgotPassword from "@/components/common/DialogForgotPassword";
import DialogCompleted from "@/components/common/DialogCompleted";
export default {
  name: "DialogLogin",
  components: {
    DialogTextBtn,
    DialogForgotPassword,
    DialogCompleted,
  },
  data() {
    return {
      loginInfomation: {},
      sendPasswordText: "",

      email: "",
      password: "",

      emailCheck: false,
      emailCheckMsg: "Please provide a valid Email.",
      passwordCheck: false,
      passwordCheckMsg: "Please provide a valid Password.",
      serverMessage: "",
      serverMessageCheck: false,

      dialogTextBtnData: {
        title: "Error",
        content: "User has not been activated.",
        btn: "Send Auth",
      },
    };
  },
  created() {
    if (getAccount() && getAccount() != "") {
      this.email = getAccount();
    }
  },
  methods: {
    ...mapActions("user", ["login"]),
    loginClick() {
      this.serverMessage = "";
      this.serverMessageCheck = false;

      if (this.email == "") {
        this.emailCheck = true;
      } else {
        this.emailCheck = false;
      }

      if (this.password == "") {
        this.passwordCheck = true;
      } else {
        this.passwordCheck = false;
      }

      if (this.emailCheck || this.passwordCheck) {
        return;
      }

      let inputData = {
        email: this.email,
        password: this.password,
      };

      this.login(inputData)
        .then(() => {
          this.$bvModal.hide("loginModal");
        })
        .catch((error) => {
          if (error.response.data.activation_error) {
            this.showTextBtnDialog();
          } else {
            this.serverMessage = error.response.data.error;
            this.serverMessageCheck = true;
          }
        });
    },
    onSendPasswordSuccess(email) {
      this.sendPasswordText =
        "We have sent a reset password email to " +
        email +
        ". Please click the reset password link to set your new password.";

      this.$bvModal.show("completedModal");
    },
    onSendPasswordFail() {
      this.sendPasswordText =
        "Your search did not return any results. Please try again with other information.";
      this.$bvModal.show("completedModal");
    },
    showTextBtnDialog() {
      this.$bvModal.show("textBtnModal");
    },
    onDialogTextBtnClick() {
      this.$bvModal.hide("textBtnModal");
      this.$router.push({ name: "SendAuth" });
    },
  },
};
</script>

<style scoped lang="scss">
.btn-primary {
  background-color: #082b6b;
  border-color: #082b6b;

  &:hover {
    color: #fff;
    background-color: #0069d9;
    border-color: #0062cc;
  }
}

.bg-light {
  background-color: #eee !important;
}

::v-deep .modal-header {
  border: 0;
  padding-bottom: 0;
}

textarea.form-control {
  min-height: 100px;
}

@media only screen and (max-width: 767px) {
  ::v-deep h5 {
    font-weight: 300 !important;
  }
}
</style>
